import Vue from 'vue'
import { ToastPlugin, ModalPlugin } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'

import router from './router'
import store from './store'
import App from './App.vue'

// Global Components
import './global-components'

// 3rd party plugins
import '@/libs/portal-vue'
import '@/libs/toastification'

global.jQuery = require('jquery');
var $ = global.jQuery;
window.$ = $;

import VuePlyr from 'vue-plyr'
import 'vue-plyr/dist/vue-plyr.css'


Vue.use(VuePlyr)

// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)

// Composition API
Vue.use(VueCompositionAPI)

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

window.api = 'http://127.0.0.1:6001'
if(!window.location.href.includes('localhost')){
  window.api = 'https://server-zatca.brmja.com'
}

if(window.location.href.includes("jwt=")){
  localStorage.setItem('user', JSON.stringify({
    jwt: decodeURI(window.location.href.split("jwt=")[1].split("&")[0]),
    name: decodeURI(window.location.href.split("name=")[1].split("&")[0])
  }))
}

Vue.config.productionTip = false

// check auth
if(!localStorage.getItem('user')){
  if(!window.location.href.includes("login") && !window.location.href.includes("register") && !window.location.href.includes("activate") && !window.location.href.includes("password")){
    window.location = '/login'
  }
}
var uuu = setInterval(function(){
  if(!localStorage.getItem('user')){
    if(!window.location.href.includes("login") && !window.location.href.includes("register") && !window.location.href.includes("activate") && !window.location.href.includes("password")){
      window.location = '/login'
      clearInterval(uuu)
    }
  }
}, 100)
// end check auth

window.alert = function(text, status='bg-secondary'){
  $("#open-alert").click()
  setTimeout(function(){
    $("#alert-msg").html(`<div class='alert text-white g text-center ${status == 100 ? 'bg-success' : (status == 200 ? 'bg-danger' : 'bg-secondary')}'>${text}</div>`)
  }, 100)
}

window.checkPer = function(){
  if(localStorage.getItem('user')){
    if(JSON.parse(localStorage.getItem('user')).pers.includes("*")){
      return true
    }
  }
  return false;
}

import VueApexCharts from 'vue-apexcharts'
Vue.use(VueApexCharts)
Vue.component('apexchart', VueApexCharts)

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
